// TelcoTrack — HR kontroly zaměstnanců (periodické termíny v kalendáři).

import { EQUIPMENT_SERVICE_FREQUENCY_LABELS, type EquipmentServiceFrequency } from './equipment.constants';

/** Typ kontroly / revize u zaměstnance. */
export const USER_HR_CHECK_TYPES = [
  'lekarska',
  'bozp',
  'vp',
  'ridicak',
  'vzv',
  'pozar',
  'jine',
] as const;

export type UserHrCheckType = (typeof USER_HR_CHECK_TYPES)[number];

export const USER_HR_CHECK_TYPE_LABELS_CS: Record<UserHrCheckType, string> = {
  lekarska: 'Lékařská prohlídka',
  bozp: 'BOZP / školení',
  vp: 'Vstupní prohlídka',
  ridicak: 'Řidičský průkaz',
  vzv: 'VZV / stroje',
  pozar: 'Požární ochrana',
  jine: 'Jiné',
};

export const USER_HR_CHECK_STATUSES = ['planned', 'done', 'cancelled'] as const;
export type UserHrCheckStatus = (typeof USER_HR_CHECK_STATUSES)[number];

export const USER_HR_CHECK_STATUS_LABELS_CS: Record<UserHrCheckStatus, string> = {
  planned: 'Plánováno',
  done: 'Hotovo',
  cancelled: 'Zrušeno',
};

/** Stejné frekvence jako opakované kontroly zařízení. */
export type UserHrCheckFrequency = EquipmentServiceFrequency;

export const USER_HR_CHECK_FREQUENCY_LABELS_CS = EQUIPMENT_SERVICE_FREQUENCY_LABELS;

export interface UserHrCheckEventDto {
  id: string;
  userId: string;
  checkType: UserHrCheckType;
  title: string | null;
  description: string | null;
  startsAt: string;
  endsAt: string | null;
  status: UserHrCheckStatus;
  seriesId: string | null;
  frequency: UserHrCheckFrequency | null;
  createdAt: string;
  createdBy: string | null;
}

export interface UserHrCheckCalendarRowDto {
  userId: string;
  email: string;
  firstName: string;
  lastName: string;
  jobTitle: string | null;
  region: string | null;
  checks: UserHrCheckEventDto[];
}

export interface UserHrCheckCalendarDto {
  from: string;
  to: string;
  rows: UserHrCheckCalendarRowDto[];
}

export function isUserHrCheckType(value: unknown): value is UserHrCheckType {
  return typeof value === 'string' && (USER_HR_CHECK_TYPES as readonly string[]).includes(value);
}

export function isUserHrCheckStatus(value: unknown): value is UserHrCheckStatus {
  return typeof value === 'string' && (USER_HR_CHECK_STATUSES as readonly string[]).includes(value);
}
